<template>
    <b-container v-if="expenseCategory">
        <b-row>
            <b-col>
                <h3 class="mt-3">{{ expenseCategory.id ? '修改開支分類' : '建立開支分類' }}</h3>
            </b-col>
            <b-col v-if="expenseCategory.id">
                <b-button class="mt-3 float-right" variant="danger" @click="onDelete">刪除開支分類</b-button>
            </b-col>
        </b-row>

        <b-form class="mt-3" @submit.stop.prevent="onSubmit">
            <h5>內容</h5>
            <b-form-group label="名稱">
                <b-form-input v-model="expenseCategory.name" required></b-form-input>
            </b-form-group>

            <b-row>
                <b-col>
                    <b-form-group>
                        <b-button block @click="$router.go(-1)">返回</b-button>
                    </b-form-group>
                </b-col>
                <b-col>
                    <b-form-group>
                        <b-button type="submit" variant="primary" block>儲存</b-button>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-form>
    </b-container>
</template>

<script>
import { ExpenseCategory } from '@/models'

export default {
    data() {
        return {
            action: this.$route.params.action,
            expenseCategory: null,
        }
    },

    async created() {
        this.expenseCategory = this.action == 'create' ? ExpenseCategory() : await this.$store.dispatch('getDocument', { col: 'expenseCategories', id: this.$route.params.id })
        if (!this.expenseCategory) return this.$router.push('/expenseCategories')
    },

    methods: {
        async onDelete() {
            const res = await this.$store.dispatch('deleteDocument', { col: 'expenseCategories', id: this.expenseCategory.id })
            this.$root.$bvToast.toast(`刪除${res ? '成功' :'失敗'}`, { title: res ? '成功' :'失敗', variant: res ? 'success' : 'danger' })
            return this.$router.push('/expenseCategories')
        },
        
        async onSubmit() {
            this.expenseCategory.merchantId = localStorage.merchantId

            const res = await this.$store.dispatch(this.action == 'create' ? 'createDocument' : 'updateDocument', { col: 'expenseCategories', doc: this.expenseCategory })
            this.$root.$bvToast.toast(`${this.action == 'create' ? '新增' : '更新'}${res ? '成功' :'失敗'}`, { title: res ? '成功' :'失敗', variant: res ? 'success' : 'danger' })
            return this.$router.push('/expenseCategories')
        }
    }
}
</script>